import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-si-glyph-arrow-thin-right-bottom",
  "use": "icon-si-glyph-arrow-thin-right-bottom-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" class=\"si-glyph si-glyph-arrow-thin-right-bottom\" id=\"icon-si-glyph-arrow-thin-right-bottom\">\n    <!-- Generator: Sketch 3.0.3 (7891) - http://www.bohemiancoding.com/sketch -->\n    <title>1176</title>\n    \n    <defs></defs>\n    <g stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <path d=\"M8.148,15.938 C7.575,15.94 7.114,15.624 7.116,15.053 C7.116,14.485 7.581,14.022 8.154,14.02 L13.507,14.012 L1.314,1.7 C0.95,1.339 0.957,0.744 1.331,0.373 C1.705,0.00200000002 2.301,-0.00599999998 2.665,0.355 L15.106,12.555 L15.116,7.208 C15.118,6.638 15.497,6.175 16.069,6.174 C16.354,6.172 16.967,6.553 16.967,7.201 L16.95,15.922 L8.148,15.938 L8.148,15.938 Z\" fill=\"#434343\" class=\"si-glyph-fill\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/glyph/si-glyph-arrow-thin-right-bottom.svg
// module id = Vai1
// module chunks = 62